export default {
  features: {
    index: {
      seo: {
        title: 'Todas las funciones',
        description:
          'Herramientas con IA para gestión de entregas: seguimiento de marca, optimización de rutas, agentes IA, prueba de entrega, asignación automática, análisis y más.',
      },
      badge: 'Funciones de la plataforma',
      title: 'Todas las funciones',
      subtitle:
        'Herramientas con IA para entrega, rutas, prueba de entrega y operaciones de flota. Explora cada función a continuación.',
      stats: {
        features: 'Funciones',
        aiPowered: 'Con IA',
        dispatchRouting: 'Despacho y rutas',
        uptime: 'Disponibilidad de la plataforma',
      },
      learnMore: 'Saber más',
      cta: {
        title: '¿Listo para probar Geofleet?',
        subtitle: 'Empieza ya o reserva una demo para ver estas funciones en acción.',
      },
    },
  },
};
